import { useState, useEffect, useRef } from 'react';
import { analyticsApi } from '../api';

// Single hook — all 4 calls fire in parallel via Promise.all.
// fetchingRef prevents React 18 StrictMode double-invoke double-fetch.
export function useAnalytics() {
  const [data,    setData]    = useState({
    summary:    null,
    streak:     null,
    weekly:     [],
    byCategory: [],
  });
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchingRef = useRef(false);

  useEffect(() => {
    if (fetchingRef.current) return;
    fetchingRef.current = true;

    setLoading(true);
    setError(null);

    Promise.all([
      analyticsApi.summary().catch(() => ({ data: null })),
      analyticsApi.streak().catch(() => ({ data: null })),
      analyticsApi.weekly().catch(() => ({ data: [] })),
      analyticsApi.byCategory().catch(() => ({ data: [] })),
    ]).then(([summaryRes, streakRes, weeklyRes, byCatRes]) => {
      // Unwrap both plain and { data: ... } responses
      const unwrap = (res, fallback) => {
        if (!res?.data) return fallback;
        return res.data?.data ?? res.data ?? fallback;
      };

      setData({
        summary:    unwrap(summaryRes, null),
        streak:     unwrap(streakRes,  null),
        weekly:     unwrap(weeklyRes,  []),
        byCategory: unwrap(byCatRes,   []),
      });
    }).catch(e => {
      setError(e);
    }).finally(() => {
      setLoading(false);
      fetchingRef.current = false;
    });
  }, []);

  return { ...data, loading, error };
}